import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {CreateUpdateEntityView} from '@ozgene/gp5.components.create-update-entity-view';
import {findSbs, save, canWrite} from 'Sbs/service/SbsService';
import SbsEditor from 'Sbs/components/SbsEditor';

export default function UpdateCreateSbsView(props, context) {
  const {router} = context;
  const {
    params: {sbsId = ''},
  } = props;
  const [sbs, setSbs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [canWriteSbs, setCanWriteSbs] = useState(true);
  const [permissionChecked, setPermissionChecked] = useState(false);
  const handleSave = async (sbs) => {
    const {id} = await save(sbs);

    router.push(`/Sbss/${id}`);
  };
  const handleRetrieveSbs = async (sbsId) => {
    if (sbsId) {
      setSbs(await findSbs(sbsId));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    handleRetrieveSbs(sbsId);
  }, [sbsId]);

  useEffect(() => {
    const checkWritePermission = async () => {
      if (sbsId) {
        try {
          const hasWritePermission = await canWrite(sbsId);

          setCanWriteSbs(hasWritePermission === true);
          setPermissionChecked(true);
          // Redirect if user doesn't have write permission
          if (!hasWritePermission) {
            router.push(`/Sbss/${sbsId}`);
          }
        } catch (error) {
          console.error('Error checking write permission:', error);
          setCanWriteSbs(false);
          setPermissionChecked(true);
          router.push(`/Sbss/${sbsId}`);
        }
      } else {
        // Allow create for new SBS
        setCanWriteSbs(true);
        setPermissionChecked(true);
      }
    };

    checkWritePermission();
  }, [sbsId, router]);

  // Don't render the edit form if user doesn't have permission
  if (!isLoading && permissionChecked && sbsId && !canWriteSbs) {
    return null; // Will redirect via useEffect
  }

  return (
    !isLoading &&
    permissionChecked && (
      <CreateUpdateEntityView
        entityType="SBS"
        EditorComponent={SbsEditor}
        onSave={handleSave}
        entity={sbs}
      />
    )
  );
}

UpdateCreateSbsView.contextTypes = {
  router: PropTypes.object.isRequired,
};
UpdateCreateSbsView.propTypes = {
  params: PropTypes.shape({
    sbsId: PropTypes.string,
  }),
};
